import React, { createContext, useState, useMemo, useEffect, useContext } from "react";
import { AuthContext } from "./AuthContext";

interface DirtyStateContextType {
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
}

export const DirtyStateContext = createContext<DirtyStateContextType | undefined>(
  undefined
);

export const DirtyStateProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isDirty, setIsDirty] = useState(false);

  // companyIdの変更を検知してstateをクリア
  const authContext = useContext(AuthContext);
  const currentCompanyId = authContext?.companyId;

  useEffect(() => {
    // companyIdが変更された（ログイン、ログアウト、company切り替え）場合、isDirtyをリセット
    setIsDirty(false);
  }, [currentCompanyId]);

  const value = useMemo(
    () => ({
      isDirty,
      setIsDirty,
    }),
    [isDirty]
  );

  return (
    <DirtyStateContext.Provider value={value}>
      {children}
    </DirtyStateContext.Provider>
  );
};
